import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { UPDATE_ROUTES} from './../store/stateReducer';

@Component({
  selector: 'app-step-one',
  templateUrl: './step-one.component.html',
  styleUrls: ['./step-one.component.scss']
})
export class StepOneComponent implements OnInit {

  private state: any;
  public garden = false;
  public balcony = false;
  public room = false;
  public roof = false;
  public bonsai = false;
  public other = false;

  constructor( private store: Store<any>, private router: Router ) {
    this.store
      .select(state => state.stateReducer)
      .subscribe(state => this.state = state);
  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// /Users/Dimitrios/Documents/git/dvsplanungshilfe/src/app/step-one/step-one.component.ts